/**
 * @todo This function should be called in gatsby-node while creating nodes.
 * @param {object} strain - The strain object to be flattened from the markdown file.
 * @returns {object} - The flattened strain object with id, slug, and frontmatter properties.
 */
export function flattenStrain(strain) {
  const { id, frontmatter, fields } = strain.childMarkdownRemark
  return {
    id: id,
    slug: fields.slug,
    ...frontmatter,
  }
}
